import { useLocationAddressQuery } from '../api/queries';

type Props = { af: string | null };

export default function LocationAddress({ af }: Props) {
  const { data, isLoading, error } = useLocationAddressQuery(af);

  if (!af) return <span className="empty">—</span>;
  if (isLoading) return <span className="empty">Loading...</span>;
  if (error || !data) return <span className="empty">Unable to load</span>;

  const { hasZoho, hasYext, matchLevel, zoho, yext, typo } = data;

  if (!hasZoho) {
    if (hasYext) {
      return (
        <>
          <div>{yext.fullAddress}</div>
          <div
            title="No Zoho office address on file. Showing Yext address instead."
            style={{
              marginTop: 4,
              display: 'inline-block',
              padding: '2px 8px',
              background: '#eef2ff',
              color: '#4338ca',
              borderRadius: 4,
              fontSize: 11,
              fontWeight: 600,
            }}
          >
            from Yext
          </div>
        </>
      );
    }
    return <span className="empty">No address on file</span>;
  }

  let indicator: React.ReactNode = null;
  if (matchLevel === 'no-yext' || !hasYext) {
    indicator = (
      <div
        title="No Yext listing configured for this location"
        style={{
          marginTop: 4,
          color: '#8a95a5',
          fontSize: 11,
          fontWeight: 500,
          textAlign: 'left',
        }}
      >
        (no Yext)
      </div>
    );
  } else if ((matchLevel === 'exact' || matchLevel === 'close') && typo) {
    indicator = (
      <div
        title={`Yext address: ${yext.fullAddress}\nZoho address: ${zoho.fullAddress}`}
        style={{
          marginTop: 4,
          color: '#b45309',
          fontSize: 12,
          fontWeight: 700,
          textAlign: 'left',
        }}
      >
        <span style={{ fontSize: 15 }}>⚠</span> Possible misspelling in the address
      </div>
    );
  } else if (matchLevel === 'exact' || matchLevel === 'close') {
    const title =
      matchLevel === 'exact'
        ? 'Yext address matches Zoho exactly'
        : 'Yext address matches Zoho (zip/city/state align)';
    indicator = (
      <div
        title={title}
        style={{
          marginTop: 4,
          color: '#16a34a',
          fontSize: 12,
          fontWeight: 700,
          textAlign: 'left',
        }}
      >
        <span style={{ fontSize: 15 }}>✔</span> Yext Matches Zoho
      </div>
    );
  } else {
    indicator = (
      <div
        title={`Yext address differs from Zoho (match level: ${matchLevel})`}
        style={{
          marginTop: 4,
          color: '#dc2626',
          fontSize: 12,
          fontWeight: 700,
          textAlign: 'left',
        }}
      >
        <span style={{ fontSize: 15 }}>✗</span> Yext ≠ Zoho
      </div>
    );
  }

  return (
    <>
      <div>{zoho.fullAddress}</div>
      {indicator}
    </>
  );
}
